import { RefObject, useRef, useState } from "react";
import { t } from "i18next";
import moment from "moment";
import Calendar from "react-calendar";
import { useSelector } from "react-redux";
import { useOnClickOutside } from "usehooks-ts";

import { DateFormats } from "@enums/shared.enum";
import { useBooking } from "@hooks/useBooking/useBooking";
import { RootState } from "@store/index";

import "react-calendar/dist/Calendar.css";

const Header = () => {
  const { gotoToday, selectFuture } = useBooking();
  const [showCalender, setShowCalender] = useState(false);
  const { selectedDate } = useSelector((State: RootState) => State.booking);

  const { selectedLanguage } = useSelector((state: RootState) => state.user);

  const calendarRef = useRef<HTMLDivElement>(null);

  // Handle outside click to close calendar
  useOnClickOutside(calendarRef as RefObject<HTMLDivElement>, () => {
    setShowCalender(false);
  });

  return (
    <div className="fg-booking-header" data-testid="booking-header-test">
      <h4 className="fg-selected-year">
        {moment(selectedDate).format(DateFormats.Y)}
      </h4>
      <div className="fg-booking-header-right">
        <button
          className={`btn fg-btn fg-btn-small ${selectedDate === moment().format(DateFormats.YMD) && "active"} `}
          onClick={gotoToday}
        >
          {t("today")}
        </button>
        <div className="fg-date-wrap" ref={calendarRef}>
          <button
            className="btn fg-icon-btn"
            onClick={() => {
              setShowCalender(!showCalender);
            }}
          >
            <i className="fa-solid fa-calendar" />
          </button>
          {showCalender && (
            <Calendar
              locale={selectedLanguage}
              maxDate={moment()
                .add(DateFormats.OneYear, DateFormats.Days)
                .toDate()}
              minDate={moment().toDate()}
              onClickDay={e => {
                selectFuture(moment(e).format(DateFormats.YMD));
              }}
              view="month"
              value={moment(selectedDate).toDate()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
